import React, {FC, PropsWithChildren} from 'react';

import {VisuallyHiddenProps} from './VisuallyHidden.types';

import './VisuallyHidden.scss';

const VisuallyHidden: FC<PropsWithChildren<VisuallyHiddenProps>> = ({
    as: Tag = 'span',
    children,
    ...props
}) => {
    return (
        <Tag className="sr-only" {...props}>
            {children}
        </Tag>
    );
};
export default VisuallyHidden;
